import React from "react";
import { KpiScoreCard } from "@sia/style-guide";
import { KPI_SCORECARD_TRANSLATION_KEYS, MINOR_KPI_TRANSLATION_KEYS } from "./kpiConfiguration";
import {
  formatDirectToIndirect,
  formatKpiBadgeDifference,
  formatKpiBadgeValue,
  formatKpiScaleValue,
  getKpiUnitLabel,
  isKpiDifferenceRoundedToZero,
} from "./data/kpiFormatters";

export default function KpiScorecardSection({ title, kpis, size = "default", translate, currency, showOwnData }) {
  return (
    <section className={`sia-key-figures-scorecards${size === "compact" ? " sia-key-figures-scorecards--minor" : ""}`} aria-label={title}>
      <div className="sia-key-figures-scorecards__header">
        <h3>{title}</h3>
      </div>

      <div className="sia-key-figures-scorecards__grid">
        {kpis.map((kpi) => {
          return (
            <KpiScoreCard
              key={`${kpi.id}-${kpi.period || "latest"}`}
              size={size}
              title={kpi.title}
              formulaLabel={translate(KPI_SCORECARD_TRANSLATION_KEYS.formulaLabel)}
              interpretationLabel={translate(KPI_SCORECARD_TRANSLATION_KEYS.interpretationLabel)}
              formula={kpi.formula}
              unitLabel={getKpiUnitLabel(kpi.unit, currency)}
              interpretation={kpi.interpretation}
              mean={kpi.mean}
              sd={kpi.sd}
              respondentValue={kpi.respondentValue}
              direction={kpi.direction}
              showRespondent={showOwnData}
              formatValue={(value) => formatKpiBadgeValue(value, kpi.unit, kpi.decimals)}
              formatScaleValue={(value) => formatKpiScaleValue(value, kpi.unit, currency)}
              formatDifference={(value) => formatKpiBadgeDifference(value, kpi.unit, kpi.decimals)}
              isDifferenceZero={(value) => isKpiDifferenceRoundedToZero(value, kpi.unit, kpi.decimals)}
              secondaryMetric={
                kpi.secondaryMetric
                  ? {
                      label: translate(MINOR_KPI_TRANSLATION_KEYS.directToIndirect),
                      formatValue: formatDirectToIndirect,
                    }
                  : undefined
              }
            />
          );
        })}
      </div>
    </section>
  );
}
